import { memo } from 'react';
import { Box, CssBaseline, Grid, Stack } from '@mui/material';
import PageMainTitle from 'components/cmn/PageMainTitle';
import { useProject } from 'hooks/useProject';
import ProjectSelectType from 'components/project/create/ProjectSelectType';

function ProjectCreatePage(): JSX.Element {
  const { getCommCodeGroup } = useProject();
  const { data } = getCommCodeGroup();
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <PageMainTitle title="프로젝트 유형 선택" />
        </Grid>
        <Grid item xs={12}>
          <Stack spacing="50px" alignContent="center" justifyContent="center" sx={{ display: 'flex' }}>
            {data
              ?.filter(obj => obj.codeValue !== 'ME')
              ?.map(obj => <ProjectSelectType key={obj.codeValue} type={obj} />)}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(ProjectCreatePage);
